/** Perwalian (Dosen PA) live queries: konsultasi + PA-link requests. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { KonsultasiPaDoc, PaRequestDoc } from '../../types';

/** Konsultasi PA of a mahasiswa. */
export function useKonsultasiPa(mahasiswaId: string | null) {
  return useLiveQuery<KonsultasiPaDoc>(
    mahasiswaId ? COL.konsultasiPa : null,
    mahasiswaId ? [where('mahasiswaId', '==', mahasiswaId), orderBy('tanggal', 'desc')] : [],
    Boolean(mahasiswaId),
  );
}

/** Konsultasi PA inbox for a Dosen PA (perwalian). */
export function useKonsultasiPaForDosen(dosenPaId: string | null) {
  return useLiveQuery<KonsultasiPaDoc>(
    dosenPaId ? COL.konsultasiPa : null,
    dosenPaId ? [where('dosenPaId', '==', dosenPaId), orderBy('tanggal', 'desc')] : [],
    Boolean(dosenPaId),
  );
}

/** Dosen PA requests made by a mahasiswa (latest first). */
export function usePaRequests(mahasiswaId: string | null) {
  return useLiveQuery<PaRequestDoc>(
    mahasiswaId ? COL.paRequests : null,
    mahasiswaId ? [where('mahasiswaId', '==', mahasiswaId), orderBy('createdAt', 'desc')] : [],
    Boolean(mahasiswaId),
  );
}

/** Dosen PA requests awaiting/after a dosen's decision (latest first). */
export function usePaRequestsForDosen(dosenId: string | null) {
  return useLiveQuery<PaRequestDoc>(
    dosenId ? COL.paRequests : null,
    dosenId ? [where('dosenId', '==', dosenId), orderBy('createdAt', 'desc')] : [],
    Boolean(dosenId),
  );
}
